module.exports = __webpack_public_path__ + "static/media/KFOlCnqEu92Fr1MmSU5fBxc4AMP6lbBP.e91a24f2.woff2";